import React, { useState } from 'react';
import { UploadType } from '../constants';
import { AxiosPrivate } from '../utils/axios';

export const useDeleteCommentAttachment = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [toDeleteFileIndex, setDeleteFileIndex] = useState(0);

  const deleteAttachment = async (
    attachmentId: string,
    uploadType: UploadType = UploadType.CommentAttachment,
    fileIndex: number,
  ): Promise<void> => {
    let urlPrefix = 'comment-attachments';

    if (uploadType === UploadType.ResponseAttachment) {
      urlPrefix = 'response-attachments';
    }

    try {
      const url = `/${urlPrefix}/${attachmentId}`;
      setDeleteFileIndex(fileIndex);
      setIsDeleting(true);

      await AxiosPrivate.delete(url);
    } finally {
      setIsDeleting(false);
      setDeleteFileIndex(0);
    }
  };

  return {
    isDeleting,
    toDeleteFileIndex,
    deleteAttachment,
  };
};
